import { render } from "./logo-item.vue?vue&type=template&id=91998f44&ts=true"
import script from "./logo-item.vue?vue&type=script&lang=ts"
export * from "./logo-item.vue?vue&type=script&lang=ts"

import exportComponent from "/azp/agent/_work/1/s/frontend-financier/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__